export const ActivityCategoryConstants = {
  RELOADING_OF_HUNTING_AMMUNITION_LEGACY:'b954d822-7fbc-4fb0-aaa9-1b79518e227c',
  RELOADING_COURSE_HUNTER: '4b121404-812b-4eff-afd9-1ef1bf2a00c3',
  SIGHTING_OF_SCOPE_HUNTER: 'b2501c65-16de-4193-9e3b-396d31aea5ce',
  RELOADING_COURSE_SPORT: 'e64ca270-25ab-4438-909a-534763de37e4',
  SIGHTING_OF_SCOPE_SPORT: '421a6e60-2f7a-4bd7-af42-2e41a7ceef10',
  HUNT_RELATED_EXPO_OR_SHOW: '0d15a3a6-5065-4162-ba0c-3f3a16f3b142',
  DAMAGE_CAUSING_ANIMAL_CONTROL: '11fa9e26-2de8-44ca-b766-6a4bc0d4126b',
  RELOADING_DEVELOPMENT_OF_HUNTING_AMMUNITION_LOAD:'834900d6-49f5-4799-84e4-81f60d773c2b',
  CULLING_OF_GAME_ANIMALS: '19669519-6578-41d0-9c7d-8e77a9b57752',
  HUNTING_OF_FURRED_GAME: '672a6fa5-5223-4f98-b2ec-8fd502807b97',
  GUN_DOG_TRAINING: '4523cd85-0e3d-4676-813a-9d64a2573f0d',
  FORMAL_HUNT_RELATED_MEETING: '0bd21001-9416-4f5f-ab1a-a64829ae4929',
  HUNTING_OF_FEATHERED_GAME: '7010ba5b-b46a-4bb2-82e7-d9b5fc3af2bc',
  HUNTERS_TRAINING_COURSE: 'ed45a48e-0a4c-440b-8a93-ead83635b2fa',
  HUNTING_TARGET_PRACTICE: '1e41972c-aa21-4f8f-ba96-f39ccd48a42d',
  BUILDING_MAINTAIN_PUBLIC_CLUB_SHOOTING_RANGE: 'eb4e7d34-3db2-4b63-84c9-432fedb38473',
  SPORT_SHOOTING_TARGET_PRACTICE: '819894d9-4385-4be6-9e63-4b6b13b813d8',
  RANGE_OFFICER_DUTIES: 'abf95b6b-f257-4f8c-a585-4f1f81a968e5',
  RELOADING_DEVELOPMENT_OF_SPORT_SHOOTING_AMMUNITION_LOAD: 'b348b784-8d33-4685-ab10-540839564312',
  NHSA_POSTAL_SHOOT: 'bf6b9067-dbcf-423a-a147-7218f20c90bd',
  ORGANISED_SHOOTING_EVENT_COMPETITION_NON_NHSA: '421c28eb-3a23-4675-a375-753dd642da26',
  SPORT_SHOOTING_TRAINING_COURSE: 'f81fd977-e82f-4b06-a6b4-8e2cf7e3ca03',
  FORMAL_SPORT_SHOOTING_RELATED_MEETING: 'fd01fde0-9793-41db-ad81-b400c43037f3',
  RELOADING_OF_SPORT_SHOOTING_AMMUNITION_LEGACY: 'b5c269d5-1155-4977-8d65-babf39bc40a6',
  LONG_DISTANCE_SHOOTING_COURSE: '8d84028a-a53a-4d2c-b2c9-c6901af91ea1',
  SPORT_SHOOTING_EXPO_OR_SHOW: 'f5192aa3-2f8d-49f2-8e06-c735e1f9ac5e',
  ORGANISED_SHOOTING_COMPETITION_NON_NHSA: '46c18915-a68b-4360-901b-cfe6f7894b6d',
  TACTICAL_FIREARM_TRAINING: '9b8ffdb1-1b8f-4738-9e25-e3e8e18dddf1',
  ORGANISED_SHOOTING_PARTICIPATION_NO_FIREARM_LINKED: '05302f64-68ba-4124-9330-505b272d0317',
  ORGANISED_HUNTING_PARTICIPATION_NO_FIREARM_LINKED: '212fbee3-4f22-4ddb-915c-bdbc4b38d903'
};

export const AnimalHunting = [
  ActivityCategoryConstants.DAMAGE_CAUSING_ANIMAL_CONTROL,
  ActivityCategoryConstants.CULLING_OF_GAME_ANIMALS,
  ActivityCategoryConstants.HUNTING_OF_FURRED_GAME,
  ActivityCategoryConstants.HUNTING_OF_FEATHERED_GAME,
];

export const PracticeHunting = [
  ActivityCategoryConstants.RELOADING_OF_HUNTING_AMMUNITION_LEGACY,
  ActivityCategoryConstants.RELOADING_COURSE_HUNTER,
  ActivityCategoryConstants.SIGHTING_OF_SCOPE_HUNTER,
  ActivityCategoryConstants.HUNT_RELATED_EXPO_OR_SHOW,
  ActivityCategoryConstants.RELOADING_DEVELOPMENT_OF_HUNTING_AMMUNITION_LOAD,
  ActivityCategoryConstants.GUN_DOG_TRAINING,
  ActivityCategoryConstants.FORMAL_HUNT_RELATED_MEETING,
  ActivityCategoryConstants.HUNTERS_TRAINING_COURSE,
  ActivityCategoryConstants.HUNTING_TARGET_PRACTICE,
];

export const PracticeSport = [
    ActivityCategoryConstants.SPORT_SHOOTING_TARGET_PRACTICE,
    ActivityCategoryConstants.ORGANISED_SHOOTING_EVENT_COMPETITION_NON_NHSA,
    ActivityCategoryConstants.RELOADING_DEVELOPMENT_OF_SPORT_SHOOTING_AMMUNITION_LOAD,
    ActivityCategoryConstants.TACTICAL_FIREARM_TRAINING,
    ActivityCategoryConstants.RANGE_OFFICER_DUTIES,
    ActivityCategoryConstants.SPORT_SHOOTING_TRAINING_COURSE,
    ActivityCategoryConstants.RELOADING_COURSE_SPORT,
    ActivityCategoryConstants.SPORT_SHOOTING_EXPO_OR_SHOW,
    ActivityCategoryConstants.FORMAL_SPORT_SHOOTING_RELATED_MEETING,
    ActivityCategoryConstants.SIGHTING_OF_SCOPE_SPORT,
];

export const ExcludeMemberFirearm = [
  ActivityCategoryConstants.RELOADING_COURSE_HUNTER,
  ActivityCategoryConstants.RELOADING_COURSE_SPORT,
  ActivityCategoryConstants.HUNTERS_TRAINING_COURSE,
  ActivityCategoryConstants.HUNT_RELATED_EXPO_OR_SHOW,
  ActivityCategoryConstants.FORMAL_HUNT_RELATED_MEETING,
  ActivityCategoryConstants.RANGE_OFFICER_DUTIES,
  ActivityCategoryConstants.SPORT_SHOOTING_TRAINING_COURSE,
  ActivityCategoryConstants.SPORT_SHOOTING_EXPO_OR_SHOW,
  ActivityCategoryConstants.FORMAL_SPORT_SHOOTING_RELATED_MEETING,
  ActivityCategoryConstants.ORGANISED_SHOOTING_PARTICIPATION_NO_FIREARM_LINKED,
  ActivityCategoryConstants.ORGANISED_HUNTING_PARTICIPATION_NO_FIREARM_LINKED,
];

export const IncludeDescriptionOfActivity = [
    ActivityCategoryConstants.ORGANISED_SHOOTING_EVENT_COMPETITION_NON_NHSA,
    ActivityCategoryConstants.TACTICAL_FIREARM_TRAINING,
    ActivityCategoryConstants.RANGE_OFFICER_DUTIES,

]

export const IncludeNatureOfMeeting = [
    ActivityCategoryConstants.FORMAL_HUNT_RELATED_MEETING,
    ActivityCategoryConstants.FORMAL_SPORT_SHOOTING_RELATED_MEETING,
];

export const IncludeTypeActivity = [
    ActivityCategoryConstants.RELOADING_COURSE_SPORT,
    ActivityCategoryConstants.SPORT_SHOOTING_EXPO_OR_SHOW,
    ActivityCategoryConstants.SPORT_SHOOTING_TRAINING_COURSE,
];
